module.exports = __webpack_public_path__ + "static/media/mobisoft_new_logo.8982ee30.svg";